import { render } from "./LoadingSpinnerIcon.vue?vue&type=template&id=235c0bc8&scoped=true"
const script = {}

import "./LoadingSpinnerIcon.vue?vue&type=style&index=0&id=235c0bc8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235c0bc8"]])

export default __exports__